module.exports = (__webpack_require__(3340))(10);